const APOLLO_CLIENT_URI = import.meta.env.VITE_APOLLO_CLIENT_URI;

const fetchWrapper = (request) => {
  return fetch(APOLLO_CLIENT_URI, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(
    (res) =>
      new Promise((resolve, reject) => {
        res
          .json()
          .then(({ errors, data }) => {
            if (errors) {
              reject(errors[0].message);
            } else {
              resolve(data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      })
  );
};

export const fetchCurrentUser = () => {
  const request = {
    query: `
      mutation RefreshToken {
        refreshToken {
          id
          email
          roles
          token
          avatar
          firstName
          plan
          intercomUserHash
        }
      }
    `,
  };

  return fetchWrapper(request);
};

export const signInUser = (email, password) => {
  const request = {
    query: `
      mutation SignInUser($email: String!, $password: String!) {
        signInUser(email: $email, password: $password) {
          id
          email
          roles
          token
          avatar
          firstName
          plan
          intercomUserHash
        }
      }
    `,
    variables: {
      email,
      password,
    },
  };

  return fetchWrapper(request);
};

export const signOutUser = (id) => {
  const request = {
    query: `
      mutation SignOutUser($id: ID!) {
        revokeTokens(id: $id) {
          message
        }
      }
    `,
    variables: {
      id,
    },
  };

  return fetchWrapper(request);
};

export const signUpUser = (email, password, companyName, agreeToTerms) => {
  const request = {
    query: `
      mutation SignUpUser($email: String!, $password: String!, $companyName: String, $agreeToTerms: Boolean!) {
        signUpUser(email: $email, password: $password, companyName: $companyName, agreeToTerms: $agreeToTerms) {
          id
          email
          roles
          token
          avatar
          firstName
          plan
          intercomUserHash
        }
      }
    `,
    variables: {
      email,
      password,
      companyName,
      agreeToTerms,
    },
  };

  return fetchWrapper(request);
};

export const verifySignUpUser = (verificationToken) => {
  const request = {
    query: `
      mutation VerifySignUpUser($verificationToken: String!) {
        verifySignUpUser(verificationToken: $verificationToken) {
          email
          verified
        }
      }
    `,
    variables: {
      verificationToken,
    },
  };

  return fetchWrapper(request);
};

export const resetPassword = (email) => {
  const request = {
    query: `
      mutation ResetPassword($email: String!) {
        resetPassword(email: $email) {
          email
        }
      }
    `,
    variables: {
      email,
    },
  };

  return fetchWrapper(request);
};

export const verifyResetPassword = (resetToken, password) => {
  const request = {
    query: `
      mutation VerifyResetPassword($resetToken: String!, $password: String!) {
        verifyResetPassword(resetToken: $resetToken, password: $password) {
          email
        }
      }
    `,
    variables: {
      resetToken,
      password,
    },
  };

  return fetchWrapper(request);
};

export const resendVerificationToken = (email) => {
  const request = {
    query: `
      mutation SendNewVerificationToken($email: String!) {
        sendNewVerificationToken(email: $email) {
          email
        }
      }
    `,
    variables: {
      email,
    },
  };

  return fetchWrapper(request);
};

export const agreeToTerms = (email, agreeToTerms) => {
  const request = {
    query: `
      mutation AgreeToTerms($email: String!, $agreeToTerms: Boolean!) {
        agreeToTerms(email: $email, agreeToTerms: $agreeToTerms) {
          email
        }
      }
    `,
    variables: {
      email,
      agreeToTerms,
    },
  };

  return fetchWrapper(request);
};
